<template>
  <div class="ion-page">
    <ion-header class="rp-mobile">
      <ion-toolbar class="mobile-header-toolbar">
        <ion-buttons v-slot: start>
          <ion-menu-button></ion-menu-button>
          <ion-title>My eWallet</ion-title>
          <ion-icon :icon="homeSharp" class="ion-margin ios" @click="homePage"></ion-icon>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-header class="rp-desktop">
      <ion-toolbar>
        <ion-buttons v-slot: start>
          <ion-menu-button></ion-menu-button>
        </ion-buttons>
        <ion-title>My eWallet</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <UserWallet />
    </ion-content>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { IonHeader, IonToolbar, IonButtons, IonMenuButton, IonTitle, IonContent, IonIcon } from "@ionic/vue";

import UserWallet from "@/components/customer/UserWallet.vue";
import { homeSharp } from "ionicons/icons";

export default defineComponent ({
  name: 'wallet',
  components: {
    IonHeader, IonToolbar, IonButtons, IonMenuButton, IonTitle, IonContent, UserWallet, IonIcon
  },
  data() {
    return {
      homeSharp
    }
  },
  methods: {
    homePage() {
      let userRole = localStorage.getItem("user.roleId")
      if(userRole == 2) {
        this.$router.push("/customer/reservation")
      }
    },
  }
})
</script>

<style scoped>
.ios ion-icon {
  color: white;
  position: relative;
  left:70%;
}
@media (max-width: 768px) {
  .mobile-header-toolbar {
    --background: #21b24b;
  }
  .mobile-header-toolbar {
    height: 56px;
    padding-top: 1px;
  }
  .mobile-header-toolbar ion-title {
    color: #ffffff;
  }
  .mobile-header-toolbar ion-buttons {
    color: #ffffff;
    --background: #ffffff;
  }
  .mobile-header-toolbar ion-menu-button {
    color: #ffffff;
    margin-right: 13px;
  }
}
</style>